import { render, staticRenderFns } from "./foo.vue?vue&type=template&id=07ac4b13&"
import script from "./foo.vue?vue&type=script&lang=js&"
export * from "./foo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports